import { map } from 'lodash/fp';
import { TimeUnit } from '@mews/enums';
import { DateTime, DateTimeService } from '@mews/framework';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { dateTimeToUtc } from '@mews-commander/utils';
import { DAY_WIDTH, HOUR_WIDTH, MONTH_WIDTH } from '../constants';

const ERROR_MESSAGE = 'Time unit not provided';

export const getColumnWidthByTimeUnit = (timeUnit = TimeUnit.Day) => {
    switch (timeUnit) {
        case TimeUnit.Hour:
            return HOUR_WIDTH;
        case TimeUnit.Month:
            return MONTH_WIDTH;
        default:
            return DAY_WIDTH;
    }
};

export const generateColumnUnit = (dateTime: $TSFixMe, timeUnit = TimeUnit.Day) => {
    const { appLocalizationComponent } = getContainer()();

    switch (timeUnit) {
        case TimeUnit.Hour:
            return appLocalizationComponent.localizeShortTime(dateTime);
        case TimeUnit.Day:
            return `${appLocalizationComponent.localizeShortDayName(dateTime)} ${DateTimeService.getDate(dateTime)}`;
        case TimeUnit.Month:
            return appLocalizationComponent.localizeMonthName(dateTime);
        default:
            throw Error(ERROR_MESSAGE);
    }
};

export const getParentUnit = (dateTime: $TSFixMe, timeUnit = TimeUnit.Day) => {
    switch (timeUnit) {
        case TimeUnit.Hour:
            return DateTimeService.getDate(dateTime);
        case TimeUnit.Day:
            return DateTimeService.getMonth(dateTime);
        case TimeUnit.Month:
            return DateTimeService.getYear(dateTime);
        default:
            throw Error(ERROR_MESSAGE);
    }
};

export const generateParentUnitPeriodLabel = (dateTime: $TSFixMe, timeUnit = TimeUnit.Day) => {
    const { appLocalizationComponent } = getContainer()();

    switch (timeUnit) {
        case TimeUnit.Hour:
            return `${appLocalizationComponent.localizeShortDayName(dateTime)} ${appLocalizationComponent.localizeDate(
                dateTime
            )}`;
        case TimeUnit.Day:
            return `${appLocalizationComponent.localizeMonthName(dateTime)} ${DateTimeService.getYear(dateTime)}`;
        case TimeUnit.Month:
            return `${DateTimeService.getYear(dateTime)}`;
        default:
            throw Error(ERROR_MESSAGE);
    }
};

export const timeUnitDateTimeOptimization = (utcString: string, timeUnit: $TSFixMe) => {
    if (timeUnit === TimeUnit.Day || timeUnit === TimeUnit.Hour) {
        return utcString.substring(0, 15) + '0:00.000Z';
    }
    if (timeUnit === TimeUnit.Month) {
        return utcString.substring(0, 13) + ':00:00.000Z';
    }
    return utcString;
};

export const getTimeUnitScale = (timeUnit: TimeUnit, dateTime: DateTime) => {
    switch (timeUnit) {
        case TimeUnit.Day:
            return 24;
        case TimeUnit.Hour:
            return 1;
        case TimeUnit.Month: {
            const daysCount = DateTimeService.daysInMonth(dateTime);
            return daysCount * 24;
        }
        default:
            throw Error('Time unit not provided');
    }
};

export const getTimeUnitIndexDate = (fromDateTime: $TSFixMe, index: $TSFixMe, timeUnit = TimeUnit.Day) =>
    // @ts-expect-error $TSFixMeError: Argument of type 'TimeUnit' is not assignable to parameter of type 'DateTimePart'.
    DateTimeService.add(timeUnit)(fromDateTime, index);

export const getArrowsNavigationDistance = ({ timeUnit = TimeUnit.Day, fast }: $TSFixMe) => {
    const columnWidth = getColumnWidthByTimeUnit(timeUnit);

    switch (timeUnit) {
        case TimeUnit.Hour:
            return columnWidth * (fast ? 24 : 12);
        case TimeUnit.Day:
            return columnWidth * (fast ? 30 : 7);
        case TimeUnit.Month:
            return columnWidth * (fast ? 12 : 6);
        default:
            throw Error(ERROR_MESSAGE);
    }
};

const dateConverter = (origin: $TSFixMe, index: $TSFixMe, timeUnit: $TSFixMe) =>
    dateTimeToUtc(getTimeUnitIndexDate(origin, index, timeUnit));

// @ts-expect-error $TSFixMeError: Parameter 'timeUnit' implicitly has an 'any' type.
export const intervalToUTC = ({ low, high }: $TSFixMe, timeUnit, origin) => ({
    endUtc: dateConverter(origin, high, timeUnit),
    startUtc: dateConverter(origin, low, timeUnit),
});

export const convertIntervalSetToUtcRanges = (intervalSet: $TSFixMe, timeUnit: $TSFixMe, origin: $TSFixMe) =>
    map((interval) => intervalToUTC(interval, timeUnit, origin))(intervalSet);
